module.exports = __webpack_public_path__ + "media/images/story/logo-7f34015b90afe3be231c9139a55c4419.png";